import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Clock, Lock, ChevronDown } from "lucide-react";
import Stage1Video from "@/components/Stage1Video";

function StepRow({ step, isPro }) {
  const open = isPro || (step.free && !step.video);
  return (
    <li className="flex items-start gap-2.5 py-1.5 text-sm" data-testid={`step-${step.number}`}>
      <span className="mt-0.5 w-12 shrink-0 text-xs font-semibold text-neutral-400">Step {step.number}</span>
      <div className="min-w-0 flex-1">
        <p className={open ? "text-neutral-800" : "text-neutral-600"}>{step.title}</p>
        {!isPro && step.video && <p className="mt-0.5 text-xs text-neutral-500" data-testid={`step-${step.number}-video-lock`}>Video unlocks with Pro.</p>}
      </div>
      {!isPro && (open
        ? <span className="tenant-text shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold" style={{ backgroundColor: "var(--tenant-primary-light)" }} data-testid={`step-${step.number}-unlocked`}>Free</span>
        : <Lock size={13} className="mt-0.5 shrink-0 text-neutral-400" data-testid={`step-${step.number}-locked`} />)}
    </li>
  );
}

export default function PartCard({ lesson, isPro, expanded, selected, onToggle, onUnlock }) {
  const hasFree = !isPro && lesson.steps.some((s) => s.free);
  return (
    <div className={`overflow-hidden rounded-2xl border transition-colors ${selected ? "tenant-border tenant-light-bg" : "border-[#E5E2DC] bg-white"}`} data-testid={`lesson-card-${lesson.key}`}>
      <button data-testid={`lesson-${lesson.key}`} onClick={onToggle} className="flex w-full items-center gap-4 p-4 text-left">
        <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-xl ${selected ? "tenant-bg" : "bg-neutral-100"}`}>
          {lesson.locked ? <Lock size={16} className="text-neutral-500" /> : <BookOpen size={16} className={selected ? "text-white" : "tenant-text"} />}
        </span>
        <div className="min-w-0 flex-1">
          <p className="font-medium text-neutral-800">Part {lesson.part}: {lesson.title}</p>
          <p className="flex items-center gap-1.5 text-xs text-neutral-500"><Clock size={12} /> {lesson.duration} · {lesson.steps.length ? `${lesson.steps.length} steps` : "Steps coming soon"}</p>
        </div>
        <ChevronDown size={18} className={`shrink-0 text-neutral-400 transition-transform duration-300 ${expanded ? "rotate-180" : ""}`} />
      </button>
      {expanded && (
        <div className="border-t border-[#E5E2DC] px-4 pb-4 pt-3" data-testid={`lesson-steps-${lesson.key}`}>
          {lesson.locked && (
            <button data-testid={`video-lock-${lesson.key}`} onClick={onUnlock} className="mb-3 flex w-full items-center gap-2 rounded-xl bg-neutral-50 px-3 py-2.5 text-left text-sm text-neutral-600 hover:bg-neutral-100">
              <Lock size={14} className="shrink-0 text-neutral-400" /> Video lessons unlock with Pro.
            </button>
          )}
          {lesson.key === "part1" && (
            <div className="mb-3 lg:hidden">
              <Stage1Video testid="intro-video-stage1-mobile" />
            </div>
          )}
          {lesson.steps.length ? (
            <ul>{lesson.steps.map((s) => <StepRow key={s.number} step={s} isPro={isPro} />)}</ul>
          ) : (
            <p className="text-sm text-neutral-500" data-testid={`steps-coming-soon-${lesson.key}`}>Steps coming soon.</p>
          )}
          {hasFree && (
            <Link to="/roadmap" data-testid="free-stage-link" className="tenant-text mt-3 inline-block text-sm font-medium hover:underline">
              Steps 1–4 are free: open the Meet Your P&L checklist →
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
